import Img from "../../assets/img/tgStep1.png";
import Img2 from "../../assets/img/tgStep2.png";
import Img3 from "../../assets/img/tgStep3.png";
import Img4 from "../../assets/img/tgStep4.png";

import styles from "../../ui/Tooltip/Tooltip.module.scss";

export const stepsDataTokenTgBot = [
  {
    title: "Вход в Telegram и поиск @BotFather",
    description: (
      <ul className={styles.ulListContainer}>
        <li>
          Откройте приложение Telegram на вашем устройстве (или используйте
          веб-версию).
        </li>
        <li>
          В строке поиска введите @BotFather — это официальный бот Telegram для
          управления ботами.
        </li>
        <li>
          Выберите бота @BotFather из списка (он будет с галочкой подтверждения)
        </li>
      </ul>
    ),
    imgSrc: Img,
  },
  {
    title: "Начало работы с @BotFather",
    description: (
      <ul className={styles.ulListContainer}>
        <li>
          Нажмите кнопку Start (или введите /start вручную), чтобы активировать
          @BotFather.
        </li>
        <li>
          Вы увидите список доступных команд. Основные команды для создания и
          управления ботами: <div> /newbot — создать нового бота.</div>{" "}
          <div>/mybots — просмотреть и настроить уже созданные боты.</div>
        </li>
      </ul>
    ),
    imgSrc: Img2,
  },
  {
    title: "Создание нового бота",
    description: (
      <ul className={styles.ulListContainer}>
        <li>Введите команду /newbot и отправьте.</li>
        <li>
          @BotFather попросит вас ввести имя для вашего бота.
          <div>
            Пример: МойПервыйБот. Это имя будет отображаться в профиле вашего
            бота.
          </div>
        </li>
        <li>
          Затем вам нужно указать уникальное имя пользователя бота (username).
          Оно должно заканчиваться на bot.
          <div>Пример: MyFirstBot или ExampleHelperBot.</div>
        </li>
      </ul>
    ),
    imgSrc: Img3,
  },
  {
    title: "Получение токена",
    description: (
      <ul className={styles.ulListContainer}>
        <li>
          После успешного создания бота @BotFather отправит вам сообщение с
          токеном API.
          <div>Пример токена: 123456789:ABCDEF1234ghIkl-zyx57W2v1u123ew11.</div>
        </li>
        <li>Скопируйте этот токен.</li>
      </ul>
    ),
    imgSrc: Img4,
  },
];
